import { UserStatusDot } from "../../core/components/StatusDot/ContractStatusDot";
import { constantToDisplayName } from "../../core/constantToDisplayName";
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Box, Checkbox, Text, propStyling, tombac } from 'tombac';
import { InfoIcon } from 'tombac-icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = styled.ul.withConfig({
  displayName: "ContractUserList__Container"
})(["all:initial;display:block;", ""], propStyling);
const UserEmail = styled.span.withConfig({
  displayName: "ContractUserList__UserEmail"
})(["flex:auto;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
const UserLi = styled.li.withConfig({
  displayName: "ContractUserList__UserLi"
})(["all:initial;display:block;padding:", ";transition:background-color 0.1s ease-out;", ";&:hover{background-color:", ";}"], ({
  $padding
}) => tombac.parse($padding), ({
  disabled
}) => tombac.text({
  color: disabled ? tombac.color('neutral') : tombac.color.black,
  fontSize: 12,
  fontWeight: 600
}), ({
  disabled
}) => disabled ? undefined : tombac.color('neutral', 300));
const UserLiInfo = styled.div.withConfig({
  displayName: "ContractUserList__UserLiInfo"
})(["", " a{color:", ";}"], tombac.text({
  color: '#ccc'
}), tombac.color('accent', 500));
const UserContainer = styled.label.withConfig({
  displayName: "ContractUserList__UserContainer"
})(["display:flex;gap:", ";"], tombac.space(2));
const NewBadge = styled.div.withConfig({
  displayName: "ContractUserList__NewBadge"
})(["padding:2px 5px;background-color:", ";color:", ";"], tombac.color('accent', 200), tombac.color('accent', 500));
const UserRow = styled.div.withConfig({
  displayName: "ContractUserList__UserRow"
})(["border-bottom:", ";padding:", ";"], tombac.parse('1u solid --neutral-400'), tombac.parse('calc( 1sp + 0.2em) 0 1sp'));
export const ContractUserList = ({
  disabledUsers,
  itemPaddingX = '3sp',
  onSelectionChange,
  selected,
  users,
  onModalCancel,
  ...stylingProps
}) => {
  function createUserSelectionChangeHandler(user) {
    return event => {
      if (event.target.checked) {
        onSelectionChange([...selected, user]);
      } else {
        onSelectionChange(selected.filter(item => item !== user));
      }
    };
  }
  const isSelectable = selected && onSelectionChange;
  if (users.length === 0) {
    return /*#__PURE__*/_jsx(Text, {
      $pl: itemPaddingX,
      $pr: itemPaddingX,
      fontSize: 12,
      variant: "secondary",
      ...stylingProps,
      children: "There are no users assigned to this contract."
    });
  }
  function renderUserContainer({
    disabled,
    user
  }) {
    return /*#__PURE__*/_jsxs(UserContainer, {
      as: isSelectable ? 'label' : Link,
      to: `/users/edit/${encodeURIComponent(user.email)}`,
      "data-sentry-element": "UserContainer",
      "data-sentry-component": "renderUserContainer",
      "data-sentry-source-file": "ContractUserList.tsx",
      children: [' ', isSelectable && /*#__PURE__*/_jsx(Checkbox, {
        checked: selected.includes(user),
        disabled: disabled,
        label: false,
        onChange: createUserSelectionChangeHandler(user)
      }), /*#__PURE__*/_jsx(UserStatusDot, {
        $display: "inline-block",
        $mt: "-1u",
        status: user.status,
        "data-sentry-element": "UserStatusDot",
        "data-sentry-source-file": "ContractUserList.tsx",
        "data-sentry-element": "UserStatusDot"
      }), /*#__PURE__*/_jsx(UserEmail, {
        "data-sentry-element": "UserEmail",
        "data-sentry-source-file": "ContractUserList.tsx",
        "data-sentry-element": "UserEmail",
        children: user.email
      }), /*#__PURE__*/_jsxs(Box, {
        $display: "flex",
        $width: "100u",
        as: "div",
        $justifyContent: "space-between",
        "data-sentry-element": "Box",
        "data-sentry-source-file": "ContractUserList.tsx",
        "data-sentry-element": "Box",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "div",
          fontSize: 12,
          "data-sentry-element": "Text",
          "data-sentry-source-file": "ContractUserList.tsx",
          "data-sentry-element": "Text",
          children: constantToDisplayName(user.role)
        }), user.status === undefined ? /*#__PURE__*/_jsx(NewBadge, {
          children: "NEW"
        }) : null]
      }), ' ']
    });
  }
  return /*#__PURE__*/_jsx(Container, {
    ...stylingProps,
    "data-sentry-element": "Container",
    "data-sentry-component": "ContractUserList",
    "data-sentry-source-file": "ContractUserList.tsx",
    children: users.map(user => {
      const conflictingContract = disabledUsers?.filter(dUser => dUser.user.email === user.email)[0];
      const disabled = Boolean(conflictingContract);
      return /*#__PURE__*/_jsx(UserLi, {
        $padding: `0 ${itemPaddingX}`,
        disabled: disabled,
        children: /*#__PURE__*/_jsxs(UserRow, {
          children: [renderUserContainer({
            disabled,
            user
          }), disabled && /*#__PURE__*/_jsxs(UserLiInfo, {
            children: [/*#__PURE__*/_jsx(InfoIcon, {
              size: 1
            }), "User already assigned to conflicting", ' ', /*#__PURE__*/_jsx(Text, {
              as: Link,
              variant: "interactive",
              $display: "inline",
              to: `/contracts/${conflictingContract.contract.id}`,
              onClick: () => {
                onModalCancel();
              },
              children: "contract"
            })]
          })]
        })
      }, user.email);
    })
  });
};